export enum Rating {
  zero = 0,
  one = 1,
  two = 2,
  three = 3,
}
